import { TooltipProps } from '@sternum/ui';

export const dashboardNameTooltipProps: TooltipProps = {
  position: 'right',
  tooltipOffsetX: 20,
  useWrapper: false,
};
